module.exports = __webpack_public_path__ + "img/cloth_g3_shirt_15.74bbaab7.svg";